export default {
	PARTICIPANTS_AGES: 'PARTICIPANTS_AGES',
}